import { render, staticRenderFns } from "./FaCardScanner.vue?vue&type=template&id=ba95d146&scoped=true&"
import script from "./FaCardScanner.vue?vue&type=script&lang=js&"
export * from "./FaCardScanner.vue?vue&type=script&lang=js&"
import style0 from "./FaCardScanner.vue?vue&type=style&index=0&id=ba95d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba95d146",
  null
  
)

export default component.exports